module.exports = __webpack_public_path__ + "static/media/arts_20.7c996987.jpg";